export default __webpack_public_path__ + "img/total-icon.00f94f43.svg";